import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { MdOutlineLibraryBooks } from "react-icons/md";

const QuizList = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get('https://api.codingveda.com/course/get_language_quiz_topic')
      .then(res => {
        console.log("API response:", res.data.data[0]);
        setData(res.data.data);
      })
      .catch(err => console.error("Error fetching data:", err));
  }, []);


  return (
    <>
      <div className='container-fluid every_page_mg_top'>
        <div className='row' style={{ backgroundColor: "#F8F9FA" }}>
          <div className="col-md-1"></div>
          <div className="col-md-5 mt-5 p-3" style={{ display: "flex", flexDirection: 'column', gap: "10px" }}>
            <h2>Preparing For MCA Entrance</h2>
            <p>NIMCET, MCA JNU, MCA BHU, MAH CET MCA, MCA UPSEE, Jamia Millia Islamia, TANCET, MCA DU</p>
            <h5>You are at the right platform.</h5>
            <div>
              <button className='exercise_login_btn'>Login</button>
              <button className='exercise_login_btn'>Create a new account</button>
            </div>
          </div>
          <div className="col-md-6">
            <img className="lottie_files w-100" style={{ maxWidth: "70vh" }} src="../images/exams.gif" alt="" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row text-center">
          <h3 className='p-4'>Exams we cover</h3>
        </div>
        <div className='row quiz_list p-5'>
          {
            data.map((item, index) => (
              <div className="col-md-2 single_quiz_list" key={index} style={{ backgroundColor: item.bgcolor }}>
                <MdOutlineLibraryBooks style={{ fontSize: '50px' }} />
                <Link to={`/ExamView/${item.name}`} className='single_quiz_list_link'>
                  {item.name}
                </Link>
              </div>
            ))
          }
        </div>
      </div>
    </>
  );
};

export default QuizList;